module.exports = __webpack_public_path__ + "img/dox-logo.37a4bfd2.jpg";